import axios from "../axiosInstance";

class CropTypeService {
  async listCropType() {
    return await axios.get("croptype");
  }
}

export default new CropTypeService();
